<template>
  <div id="page-wrapper" :class="popupShown ? 'popup-shown' : ''">
    <transition name="userpopupdash">
      <div :class="'type-'+popupType" id="popup-wrapper" v-if="popupShown">
        <template v-if="popupType === 'user'">
          <button class="btn btn-link text-white close" @click.prevent.stop="closePopup">
            <i class="fal fa-times"></i>
          </button>
          <user-form ref="userform"
                     @newteam="savedHandler"
                     @reload="reloadHandler"
                     v-if="popupType='user'"
                     @closePopup="closePopup"
                     :userObj="activeUser"></user-form>
        </template>
        <template v-else>
          <button class="btn btn-link text-white close" @click.prevent.stop="closePopup">
            <i class="fal fa-times"></i>
          </button>
          <team-form ref="teamform"
                     @newteam="savedHandler"
                     @reload="reloadHandler"
                     v-if="popupType='team'"
                     @closePopup="closePopup"
                     :team="activeTeam"></team-form>
        </template>
      </div>
    </transition>

    <div id="page">
      <app-header></app-header>
      <div class="page-body">
        <app-navbar></app-navbar>
        <div class="main-page-content  ml-0">
          <div id="main-wrapper" class="layout-main-wrapper clearfix h-100">
            <div id="main" class="container-fluid h-100">
              <div class="row row-offcanvas row-offcanvas-left clearfix h-100">
                <main class="main-content col content-full-width h-100" id="content" role="main">
                  <!--                  <button @click="testMail">test mailer</button>-->
                  <section id="overview-manager" class="section h-100">
                    <div class="container-fluid h-100">
                      <div class="row mb-15 h-100">
                        <div class="col-left col-xxl-9 col-xl-8">
                          <div id="team-overview" class="col-card card-h-auto maximizable h-100">
                            <button class="d-block btn-enlarge maximize-btn" @click.stop="maximize($event)">
                              <i class="fas fa-expand"></i>
                            </button>
                            <button class="btn-minimize minimize-btn" @click.stop="minimize($event)">
                              <i class="fas fa-compress"></i>
                            </button>

                            <company-tree @createTeam="createTeam" ref="tree"
                                          @getTeam="getTeam"
                                          @getUser="getUser"
                                          :tree-type="'hr'"></company-tree>
                          </div>
                        </div>
                        <div class="col-right col-xxl-3 col-xl-4">
                          <div id="activity-log" class="m-0 col-card card-h-auto h-100">
                            <h2 class="d-flex justify-content-between ">
                              {{ $t('message.users') }}
                              <button v-if="role === 'hr'"
                                      @click.stop.prevent="getUser({tags: [], perks: [], children: [], role: {id: 1}})"
                                      class="btn button-link p-0">
                                + {{ $t('message.add_user') }}
                              </button>
                            </h2>
                            <input id="fname"
                                   v-on:keyup="filterUsers"
                                   name="search-user"
                                   class="styled-input form-control mb-3"
                                   type="text"
                                   :placeholder="$t('message.find_a_user')"
                                   aria-label="Search User">
                            <label class="font-italic" v-if="filter ? filter.length > 2 : false" for="">{{$t('message.user_search_result',
                              {amt:resultCount})}}</label>
                            <label class="font-italic" v-else for="">{{$t('message.recent_users')}}</label>
                            <table id="table-appointments" class="table-styled mt-3 table dataTable dataTableNoBtns">
                              <thead>
                              <tr>
                                <th scope="col">{{ $t('message.name') }}</th>
                                <!--                                <th scope="col">{{ $t('message.last_name') }}</th>-->
                                <!--                                <th scope="col">{{ $t('message.first_name') }}</th>-->
                                <th scope="col">{{ $t('message.age') }}</th>
                                <th scope="col"></th>
                              </tr>
                              </thead>
                              <!--                              <draggable-->
                              <!--                                tag="tbody"-->
                              <!--                                :list="users"-->
                              <!--                                :group="{ name: 'g2',pull: 'clone' }"-->
                              <!--                                class="dragArea "-->
                              <!--                                :start="dragClass(true)"-->
                              <!--                                @start="dragClass(true)"-->
                              <!--                                :end="endUserDrag"-->
                              <!--                                @end="endUserDrag"-->
                              <!--                                :move="moveCallback"-->
                              <!--                              >-->
                              <tbody>


                              <tr :key="user.id" :data-uid="user.id" v-for="(user,i) in users">
                                <td class="draguser">{{user.lastname}} {{user.firstname}}</td>
                                <!--                                  <td>-->
                                <!--                                    {{user.lastname}}-->
                                <!--                                  </td>-->
                                <!--                                  <td>{{user.firstname}}</td>-->
                                <td>{{user.birthdate ? calcAge(user.birthdate) : '-'}}</td>
                                <td>
                                  <button @click.prevent="getUser(user)"
                                          class="btn btn">
                                    <img class="img-fluid"
                                         src="@/assets/images/user-list-manager/edit.svg"
                                         alt="Icon edit">
                                  </button>
                                </td>
                              </tr>
                              </tbody>
                              <!--                              </draggable>-->
                            </table>
                            <p class="text-right p-0 m-0">
                              <router-link tag="a" :to="'/userlist'" v-if="role === 'hr'" @click.stop.prevent=""
                                           class="">
                                {{ $t('message.go_to_user_management') }}
                              </router-link>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>

  import Activitylog from "../Activitylog";
  import Header from "../Header";
  import Nav from "../Nav";
  // import axios from "../../axios-auth";
  import TeamTree from "../Tree/TeamTree";
  import Filter from "../Tree/Filter"
  import store from "../../store/store";
  import Userform from "../Users/Userform";
  import TeamForm from "../Teams/TeamForm";
  import draggable from "vuedraggable";
  import CompanyTree from "../Tree/CompanyTree";
  import moment from 'moment';
  import {eventPath} from "../../polyfills";

  export default {
    components: {
      CompanyTree,
      draggable,
      appHeader: Header,
      appNavbar: Nav,
      activityLog: Activitylog,
      teamTree: TeamTree,
      filterRow: Filter,
      userForm: Userform,
      teamForm: TeamForm
    },
    data() {
      return {
        role: null,
        dragActive: false,
        popupType: '',
        activeUser: {tags: [], perks: []},
        activeTeam: {parent: null},
        editing: true,
        popupShown: false,
        filterName: '',
        savedFilters: [],
        filterTrees: [],
        perks: [{key: 'car', label: 'Car'}],
        tags: [
          {key: 'car', label: 'Car'},
        ],
        filtering: false,
        store,
        resultCount: 0,
        users: [],
        loadedFilter: {name: ''},
        teams: {},
        filter: null,
        filteredTeams: null,
        showFilter: false,
        filterRows: [{
          field: '-',
          operator: '',
          value: '',
          logic: 'and'
        },]
      }
    },
    computed: {
      draggingActive() {
        return this.dragActive;
      },
      today() {
        return moment().format('YYYY-MM-DD')
      }
    },
    methods: {
      // async testMail() {
      //   const mail = await this.sendPasswordMail(
      //     'jonas@hyp3.be',
      //     'info@workvitamins.org',
      //     'Mailer fake test',
      //     'Your mail service works perfectly'
      //   );
      //   console.log('mail response', mail)
      // },
      async reloadHandler(log = null) {
     //   console.log('reload handler')
        // const log = await this.logActivity('Tree modified', 'info (HR)')
      //  console.log('logged reload event',log)
        // await this.$refs.tree.isTreeModified()
        await this.$refs.tree.fetchTree()
        this.$refs.tree.$refs.treefilter.clearFilters()
        //   .then(r => {
        //
        //   // console.log('reload handler log written')
        // });
      },
      async savedHandler(msg) {
       // console.log('saved handler')
        await this.logActivity(msg, 'info (HR)')
        await this.$refs.tree.fetchTree()
        this.$refs.tree.$refs.treefilter.clearFilters()
        //   .then(r => {
        //
        //   // this.$refs.tree.isTreeModified()
        // });
      },
      moveCallback(evt) {
        let uid = evt.dragged.dataset.uid;
        let targetUids = [];
        const targetMembers = evt.to.children;
        for (var i = 0; i < targetMembers.length; i++) {
          targetUids.push(targetMembers[i].dataset.uid);
        }
        if (targetUids.includes(uid)) {
          return false;
        }
      },
      endUserDrag(e) {
        this.dragClass(false)
        let uid = e.item.dataset.uid;
        let movedToTeamEl = e.to;
        let to_id = movedToTeamEl.dataset.parentid;
        this.moveUser(uid, to_id)
      },
      addUserToTeam(uid, t_id) {
        //  console.log('adduser', [uid, t_id])
        // let team = null;
        // this.axios.get('/teams/' + t_id).then(res => {
        //   team = res.data;
        //   let members = team.users;
        //   if (!members.includes(uid)) {
        //     members.push(uid);
        //     this.axios.put('/teams/' + t_id, {
        //       users: members
        //     }).then(res => {
        //       this.logActivity('Removed team member', 'info (HR)');
        //       //  console.log('user added to team', res.data);
        //     })
        //   }
        // });
      },
      moveUser(uid, to_id) {
        this.addUserToTeam(uid, to_id);
      },
      createTeam() {
        this.activeTeam = {parent: null};
        this.popupShown = true;
        this.popupType = 'team';
      },
      dragging(b) {
        //  console.log('hrdash dragging')
        this.dragActive = b;
      },
      getUser(user) {
        this.activeUser = user;
        this.popupShown = true;
        this.popupType = 'user';
      },
      getTeam(team) {
        this.activeTeam = team;
        this.popupShown = true;
        this.popupType = 'team';
      },
      closePopup(reload = false) {
        if (reload) {
          this.getUsers()
        }
        this.popupShown = false;
        this.popupType = '';
      },

      async loadCompanyTags() {
        return await axios.get('/tags').data;
      },

      saveFilter() {
        this.axios.post('/filters', {
          user: store.state.userId,
          title: this.filterName,
          filter: JSON.stringify(this.store.state.teamFilters)
        }).then(res => {
          this.logActivity('Created filter', 'info (HR)');
          this.filterName = '';
        })
      },

      async clearFilters() {
     //   console.log('clearing filters');
        this.filterRows = [];
        this.filtering = false;
        store.dispatch('clearFilters');
        this.resetResults();
      },

      resetResults() {
        this.filterTrees = [];
        this.filteredTeams = JSON.parse(JSON.stringify(this.teams));
      },


      getCompanyAverage() {
        this.axios.get('/averages?type=company&_sort=date:DESC&_limit=1').then(tags => tags.data)
          .then(res => {
            const data = res[0];
            this.companyAvg = data;
          });
      },

      loadTagsForFilter() {
        this.axios.get('/tags').then(tags => tags.data)
          .then(res => {
            const data = res;
            this.tags = [];
            data.forEach(tag => {
              this.tags.push({key: tag.id, label: tag.description})
            });
          });
      },

      loadPerksForFilter() {
        this.axios.get('/perks').then(perks => perks.data)
          .then(res => {
            const data = res;
            this.perks = [];
            data.forEach(perk => {
              this.perks.push({key: perk.id, label: perk.title})
            });
          });
      },
      getUserFilters() {
        // this.axios.get('/filters?user=' + store.state.userId).then(filters => filters.data)
        //   .then(res => {
        //     const data = res;
        //     this.savedFilters = data;
        //   });
      },
      initTeamData() {
        //load tree from store, find way to properly await store loading tree

        // this.axios.get('/teams').then(teams => teams.data)
        //   .then(res => {
        //     const data = res;
        //     this.teams = data[0];
        //     this.filteredTeams = data[0];
        //   });
      },

      dragClass(b = false) {
        // let tree = document.getElementsByClassName('team-tree')[0];
        // if(tree){
        //   if (b) {
        //     tree.classList.add('dragging-users-active')
        //   } else {
        //     tree.classList.remove('dragging-users-active')
        //   }
        // }
      },

      filterUsers(e) {
        this.activePage = 1
        const val = e.target.value
        this.filter = val;
        this.start = 0;
        this.getUsers(this.filter)
      },

      getUsers(filter = null) { //todo melding 'latest 10 users' wanneer er niet gefilterd wordt
        let ep = '/users';
        // let relation_search = '';
        let q = ep;
        let cq = ep + '/count';
        if (filter) {
          q += '?' + 'fullname_contains=' + filter;
          cq += '?' + 'fullname_contains=' + filter;
        } else {
          q += '?_limit=10&_sort=created_at:DESC';
          cq += '?_limit=10&_sort=created_at:DESC'
        }
        if (filter) {
          if (filter.length > 2) {
            this.queryUsers(q, cq)
          }
        } else {
          this.queryUsers(q)
        }
      },
      queryUsers(q, cq = null) {
        this.axios.get(q).then(users => users.data)
          .then(res => {
            const data = res;
            this.users = data;
          });
        if (cq) {
          this.axios.get(cq).then(users => users.data)
            .then(res => {
              const data = res;
              this.resultCount = data;
            })
        }
      },
      clickOutsidePopup() {
        // document.querySelector("body").addEventListener("mouseup", (e) => {
        //   const el = this.$el.querySelector('#popup-wrapper');
        //
        //   const path = eventPath(e);
        //   let clickedInCalendar = false;
        //   path.forEach(el => {
        //
        //     if (el.classList && (el.classList.contains('flatpickr-calendar') || el.classList.contains('vs__dropdown-menu'))) {
        //       clickedInCalendar = true
        //     }
        //   });
        //
        //   if (path.includes(el) || clickedInCalendar) {
        //   } else {
        //     this.closePopup()
        //   }
        // });
      },
    }
    ,
    created() {
      this.role = store.state.viewMode;
      // this.clickOutsidePopup();
      this.getUsers();

      this.getCompanyAverage();
      this.loadTagsForFilter();
      this.loadPerksForFilter();
      this.getUserFilters();
      this.initTeamData();
    }
    ,
  }
</script>


<style>

  @keyframes slide-in {
    from {
      top: -200%;
    }
    to {
      top: 0;
    }
  }

  @keyframes slide-out {
    from {
      top: 0;
    }
    to {
      top: -200%;
    }
  }

  .userpopupdash-enter {

  }

  .userpopupdash-enter-active {
    animation: slide-in .5s ease-out forwards;
  }

  .userpopupdash-leave {

  }

  .userpopupdash-leave-active {
    animation: slide-out .5s ease-out forwards;
  }

  .draguser {
    cursor: grab;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Hrdash.vue